import React, { FC, ReactElement } from "react";
import { useHistory } from "react-router-dom";
import "./SliderBrands.css";

interface Brand {
  id: number;
  name: string;
  image: string;
}

interface SliderBrandsProps {
  brands: Brand[];
}

const SliderBrands: FC<SliderBrandsProps> = ({ brands }): ReactElement => {
  const history = useHistory();

  if (!brands?.length) return <></>;

  const handleBrandClick = (brandName: string) => {
    history.push(`/menu?brand=${encodeURIComponent(brandName)}`);
  };

  return (
    <div className="brands-grid">
      {brands.map((brand) => (
        <div
          key={brand.id}
          className="brand-card"
          onClick={() => handleBrandClick(brand.name)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && handleBrandClick(brand.name)}
        >
          <div className="brand-logo-wrap">
            <img
              src={brand.image}
              alt={brand.name}
              className="brand-image"
              loading="lazy"
            />
          </div>
          <span className="brand-name">{brand.name}</span>
        </div>
      ))}
    </div>
  );
};

export default SliderBrands;